// @ts-nocheck

import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '@/store';
import type {
  AddUserStudiesRequest,
  AddUserStudiesResponse,
  UserStudiesResponse,
  UserStudiesRequest,
  UserResponse,
  UserCreate,
  UsersResponse,
  GetUsersParams,
  RemoveStudyFromUserRequest,
} from '@/types/user';
import { userService } from '../../services/user.service';
import { showSnackbar } from '../snakebar/slice';

export const user = {
  createUser: createAsyncThunk<UserResponse, UserCreate>(
    'users/createUser',
    async (data, { rejectWithValue }) => {
      try {
        const response = await userService.createUser(data);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Failed to create user');
      }
    }
  ),

  getUsers: createAsyncThunk<UsersResponse>('users/getUsers', async rejectWithValue => {
    try {
      const response = await userService.getUsers();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch users');
    }
  }),

  getUserStudies: createAsyncThunk<UserStudiesResponse, UserStudiesRequest>(
    'user/getUserStudies',
    async (userID, { rejectWithValue }) => {
      try {
        const response = await userService.getUserStudies(userID);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.response?.data?.message || 'Data not found');
      }
    }
  ),

  addUserStudies: createAsyncThunk<
    AddUserStudiesResponse,
    AddUserStudiesRequest,
    { dispatch: AppDispatch; state: RootState }
  >(
    'user/addUserStudies',
    async (payload: AddUserStudiesRequest, { dispatch, rejectWithValue }) => {
      try {
        await userService.addUserStudies(payload);
        dispatch(
          showSnackbar({
            message: 'Successfully added study!',
            variant: 'success',
          })
        );
        // Return empty object as per V2 API response
        return {};
      } catch (error: any) {
        dispatch(
          showSnackbar({
            message: error instanceof Error ? error.message : 'Failed',
            variant: 'error',
          })
        );
        return rejectWithValue(error.response?.data?.message || 'Failed to add user to study');
      }
    }
  ),

  removeStudyFromUser: createAsyncThunk<
    void,
    RemoveStudyFromUserRequest,
    { dispatch: AppDispatch; state: RootState }
  >(
    'user/removeStudyFromUser',
    async (payload: RemoveStudyFromUserRequest, { dispatch, rejectWithValue }) => {
      try {
        await userService.removeStudyFromUser(payload);
        dispatch(
          showSnackbar({
            message: 'Successfully removed study!',
            variant: 'success',
          })
        );
        return;
      } catch (error: any) {
        dispatch(
          showSnackbar({
            message: error instanceof Error ? error.message : 'Failed',
            variant: 'error',
          })
        );
        return rejectWithValue(error.response?.data?.message || 'Failed to remove study from user');
      }
    }
  ),
};
